// "See How It Works" — showcases the five ORIGINAL Source2Table app screenshots
// (copied from the mobile app's branding assets into /public/showcase).
const BUYER_SHOTS = [
  {
    src: "/showcase/buyer_home.jpg",
    title: "Discover local producers",
    caption: "Search nearby farms by category and see who has fresh stock available today.",
  },
  {
    src: "/showcase/buyer_producer.jpg",
    title: "Explore producer profiles",
    caption: "View live inventory, reviews and pickup options — then message or get directions.",
  },
];

const PRODUCER_SHOTS = [
  {
    src: "/showcase/producer_dashboard.jpg",
    title: "Your producer dashboard",
    caption: "Track products, reservations, ratings and buyer visibility at a glance.",
  },
  {
    src: "/showcase/producer_inventory.jpg",
    title: "Manage inventory",
    caption: "Update products and stock levels in real time, with low-stock alerts.",
  },
  {
    src: "/showcase/producer_messaging.jpg",
    title: "Message & confirm orders",
    caption: "Chat with buyers directly and confirm pickup reservations.",
  },
];

const Phone = ({ shot }) => (
  <figure data-testid={`showcase-${shot.src.split("/").pop().replace(".jpg", "")}`} className="flex flex-col items-center">
    <div className="rounded-[2rem] p-2 bg-[#1C241B] shadow-xl ring-1 ring-black/10 w-[200px] sm:w-[220px]">
      <img
        src={shot.src}
        alt={shot.title}
        loading="lazy"
        className="w-full rounded-[1.5rem] block"
        style={{ aspectRatio: "390 / 844", objectFit: "cover" }}
      />
    </div>
    <figcaption className="mt-4 text-center max-w-[220px]">
      <p className="font-sans font-bold text-[#1C241B]">{shot.title}</p>
      <p className="mt-1 text-sm text-[#5A6757] leading-snug">{shot.caption}</p>
    </figcaption>
  </figure>
);

export const Showcase = () => {
  return (
    <section data-testid="showcase-section" className="px-4 sm:px-6 py-14 bg-[#F0F4EE]">
      <div className="mx-auto max-w-6xl">
        <div className="text-center">
          <span className="text-xs sm:text-sm font-sans uppercase tracking-[0.2em] font-bold text-[#4A6B41]">
            See How It Works
          </span>
          <h2 className="mt-3 font-sans font-extrabold text-3xl sm:text-4xl text-[#1C241B] tracking-tight">
            One app, two sides of the local food network
          </h2>
        </div>

        <div className="mt-12">
          <h3 className="font-sans font-extrabold text-xl text-[#1C241B] text-center sm:text-left">
            For Buyers
          </h3>
          <div className="mt-6 flex flex-wrap justify-center gap-10">
            {BUYER_SHOTS.map((s) => (
              <Phone key={s.src} shot={s} />
            ))}
          </div>
        </div>

        <div className="mt-14">
          <h3 className="font-sans font-extrabold text-xl text-[#1C241B] text-center sm:text-left">
            For Producers
          </h3>
          <div className="mt-6 flex flex-wrap justify-center gap-10">
            {PRODUCER_SHOTS.map((s) => (
              <Phone key={s.src} shot={s} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
